import { useEffect } from "react"
import { useBrand } from "@/hooks/use-brand"

/** Sets html lang only; PageSEO handles title/meta per route. */
export function LocaleDocument() {
  const brand = useBrand()

  useEffect(() => {
    document.documentElement.lang = brand.htmlLang
  }, [brand.htmlLang])

  return null
}
